import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { Blocs } from '@business/blocs';
import { resolve } from '@core/utils/ioc';

export class AddWidgetOverlayBloc extends BaseBloc {
  private readonly blockTemplateBloc = resolve(Blocs.blockTemplate);
  loading$ = new LoadingState();

  constructor() {
    super();
  }

  readonly blockTemplates$ = this.blockTemplateBloc.templates$;
  readonly universalTemplates$ = this.blockTemplateBloc.universalTemplates$;

  onInit() {
    return this.blockTemplateBloc.fetchTemplates('proposal').pipe(this.loading$.run());
  }

  deleteTemplate = this.blockTemplateBloc.deleteTemplate;
  saveAsUniversal = this.blockTemplateBloc.saveAsUniversal;
  deleteUniversalSection = this.blockTemplateBloc.deleteUniversalSection;
}
